import { SummaryItemDetails, SummaryItemImage, SummaryItemPrice, SummaryItemWrapper } from './Summary.styles'
import { useTheme } from '../../lib/hooks'

const SummaryItem = ({ product }) => {
  const { id, imageUrl, subtitle, title, price, qty } = product
  const themes = useTheme()

  return (
    <>
      <SummaryItemWrapper key={id}>
        <SummaryItemImage>
          <img src={imageUrl} alt="" />
        </SummaryItemImage>
        <SummaryItemDetails>
          <h6>{subtitle}</h6>
          <h2>{title}</h2>
        </SummaryItemDetails>
        {themes.currency === '£' ? <SummaryItemPrice>
          <span>{qty}x</span>
          {themes.currency}
          {price.toFixed(2)}
        </SummaryItemPrice> : <SummaryItemPrice>
          <span>{qty}x</span>
          {price.toFixed(2)}
          {themes.currency}
        </SummaryItemPrice>}

      </SummaryItemWrapper>
    </>
  )
}

export default SummaryItem
